var _defs, _rect, _path, _circle, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebitCardIcon = function SvgDebitCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(34.49999 24.50002 -23.17567 32.6351 -2.5 3.5)",
    cx: 0,
    cy: 0,
    r: 1,
    id: "debitCardIcon_svg__a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#148F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571,
    stopColor: "#47D00F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#FAED00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 25.319,
    y1: 12.082,
    x2: 9.33,
    y2: 28.408,
    id: "debitCardIcon_svg__b",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAED00",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#A8DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#92D94E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2DF08"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    rx: 4,
    width: 28,
    height: 20,
    fill: "url(#debitCardIcon_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.98 11.61C30.3 13.75 27.76 15.5 24 15.5c-8.08 0-10.52 3.61-10.94 10.49-.05.82-.45 1.55-1.07 2.01H8c-2.21 0-4-1.8-4-4V12c0-2.21 1.79-4 4-4h20c2.07 0 3.78 1.58 3.98 3.61Z",
    fill: "url(#debitCardIcon_svg__b)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 13.5,
    r: 2.5,
    fill: "#CDF400",
    opacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20,
    rx: 2.5,
    width: 10,
    height: 5,
    fill: "#08A652"
  })));
};
export { SvgDebitCardIcon as ReactComponent };
export default "data:image/svg+xml;base64,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";